import { withStyles } from '@material-ui/core';

import TooltipPopper from './component';
import styles from './styles';

export default withStyles(styles)(TooltipPopper);
